module.exports = {
  SCRIPTING_FORMAT_XSLX: 'SCRIPTING_FORMAT_XSLX',
  SCRIPTING_FORMAT_TXT: 'SCRIPTING_FORMAT_TXT',
  SCRIPTING_FORMAT_YAML: 'SCRIPTING_FORMAT_YAML',
  SCRIPTING_FORMAT_CSV: 'SCRIPTING_FORMAT_CSV',
  SCRIPTING_TYPE_CONVO: 'SCRIPTING_TYPE_CONVO',
  SCRIPTING_TYPE_PCONVO: 'SCRIPTING_TYPE_PCONVO',
  SCRIPTING_TYPE_UTTERANCES: 'SCRIPTING_TYPE_UTTERANCES',
  SCRIPTING_TYPE_SCRIPTING_MEMORY: 'SCRIPTING_TYPE_SCRIPTING_MEMORY'
}
